(function () {
    'use strict';

    if (window.CAE_DISABLED === true) return;   // emergency runtime kill

    /* ============================================================
       Config
       ============================================================ */

    var ENDPOINT = (typeof window.CAE_ENDPOINT === 'string' && window.CAE_ENDPOINT) ||
                   'https://analytics-ingest-432657747828.europe-west1.run.app/cae/event';  // GCP-native ingest: Cloud Run -> Pub/Sub -> BigQuery events. (Was database-app-1 on Render.)

    var PULSE_TYPE              = 'cae_pulse';
    var QUEUE_KEY               = 'CAE_Queue';
    var UTM_KEY                 = 'CAE_Utm';
    var ENTRY_KEY               = 'CAE_Entry';
    var DEBUG_KEY               = 'CAE_Debug';
    var SESSION_START_FIRED_KEY = 'CAE_SessionStartSent';
    var LAST_CLICK_KEY          = 'CAE_LastCardClick';
    var LAST_PDP_VIEW_KEY       = 'CAE_LastPdpView';

    var FLUSH_INTERVAL_MS = 15000;
    var BATCH_SIZE        = 50;
    var MAX_QUEUE         = 500;
    var SCHEMA_VERSION    = 1;
    var IMPRESSION_DEDUP_MS = 60000;
    var SEEN_VISIBLE_RATIO  = 0.5;
    var SEEN_VISIBLE_MS     = 500;
    var ENGINE_WAIT_MS      = 100;
    var ENGINE_WAIT_MAX     = 20;       // 20 * 100ms = 2s
    var MAX_EXIT_BATCHES    = 10;       // exit flush: up to the whole queue (10 * 50 = MAX_QUEUE)

    // Crawlers that RENDER the page (measured ROW, 7 days to 2026-09-24:
    // Googlebot smartphone 1,071 sessions, meta-webindexer 207, Google-Read-Aloud
    // 102) are killed ~0.5-0.7 s in: card_seen (0.5 s) got out, card_impression
    // (1.2 s) never did - a third of all "seen but never loaded" sessions. They
    // are not shoppers, so they send nothing. Named crawlers only (plus
    // navigator.webdriver): a bare /bot/ would also hit phones like the CUBOT.
    // + GoogleOther, Google-Safety, Google-AdWords-Express, Naver Yeti, SeekportBot,
    // WebPageTest (PTST/), Amazon*Bot, PagePeeker, Dataprovider... (review of
    // 283eb9c: ~1,000 sessions a month still slipping through). Same list as the
    // ingest's _BOT_UA_RE (analytics-ingest/bq_writer.py) - keep them in step.
    var AUTOMATED_UA_RE = /googlebot|googleother|google-safety|google-adwords|adsbot|storebot-google|google-inspectiontool|google-read-aloud|mediapartners-google|bingbot|bingpreview|yandex(bot|images)|duckduckbot|baiduspider|applebot|petalbot|semrushbot|ahrefsbot|mj12bot|dotbot|seekportbot|amazon\w*bot|yeti\/|facebookexternalhit|meta-webindexer|meta-externalagent|meta-externalads|twitterbot|linkedinbot|slurp|headlesschrome|lighthouse|gtmetrix|pingdom|pagepeeker|dataprovider|canvabot|pageburst|evolizescanner|sebot-|python-requests|bytespider|ptst\/|bot\/|crawler|spider/i;
    var AUTOMATED = false;
    try { AUTOMATED = navigator.webdriver === true || AUTOMATED_UA_RE.test(navigator.userAgent || ''); } catch (e) {}

    var DEBUG = false;
    try { DEBUG = localStorage.getItem(DEBUG_KEY) === '1'; } catch (e) {}

    // Emit [cae] logs when EITHER the legacy localStorage opt-in (DEBUG_KEY) is
    // set, OR the control panel's preview-only "cae_event" console category is
    // enabled (window.AGB_consoleCat, set from the panel on PREVIEW themes only
    // — false on live, so this can never print to a shopper's console).
    function _caeLogOn() {
        if (DEBUG) return true;
        try { return !!(window.AGB_consoleCat && window.AGB_consoleCat('cae_event')); } catch (e) { return false; }
    }

    function log() {
        if (!_caeLogOn()) return;
        try {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('[cae]');
            console.log.apply(console, args);
        } catch (e) {}
    }
    function warn() {
        if (!_caeLogOn()) return;
        try {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('[cae]');
            console.warn.apply(console, args);
        } catch (e) {}
    }

    /* ============================================================
       Identity helpers — mirror the engine's precedence
       ============================================================ */

    function getCookie(name) {
        try {
            var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
            return match ? decodeURIComponent(match[1]) : null;
        } catch (e) { return null; }
    }
    function getViewerId() {
        try {
            return (localStorage.getItem('viewerId') ||
                    localStorage.getItem('visitorID') ||
                    getCookie('viewerId') ||
                    getCookie('visitorID') ||
                    null);
        } catch (e) { return null; }
    }
    function createUuid() {
        try {
            if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
        } catch (e) {}
        return 'u-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }
    function getSessionId() {
        try {
            var sid = sessionStorage.getItem('SE_SessionId');
            if (sid) return sid;
        } catch (e) {}
        try {
            var own = sessionStorage.getItem('CAE_SESSION_ID');
            if (own) return own;
            var u = createUuid();
            sessionStorage.setItem('CAE_SESSION_ID', u);
            return u;
        } catch (e) { return createUuid(); }
    }
    function getSessionStartMs() {
        try {
            var ms = parseInt(sessionStorage.getItem('SE_SessionStart') || '0', 10);
            if (ms > 0) return ms;
        } catch (e) {}
        try {
            var own = parseInt(sessionStorage.getItem('CAE_SESSION_START') || '0', 10);
            if (own > 0) return own;
            var now = Date.now();
            sessionStorage.setItem('CAE_SESSION_START', String(now));
            return now;
        } catch (e) { return Date.now(); }
    }

    /* ============================================================
       Page / device / UTM context
       ============================================================ */

    function pageType() {
        var p = location.pathname || '';
        if (/^\/products\//.test(p))                       return 'product';
        if (/\/collections\/[^\/]+\/products\//.test(p))   return 'product';
        if (/^\/collections\//.test(p))                    return 'collection';
        if (/^\/cart/.test(p))                             return 'cart';
        if (/^\/checkouts/.test(p))                        return 'checkout';
        if (p === '/' || p === '')                         return 'home';
        return 'other';
    }
    function deviceContext() {
        var ua = (navigator.userAgent || '');
        var isMobile = /Mobi|Android|iPhone|iPod/i.test(ua);
        var isTablet = /iPad|Tablet/i.test(ua);
        var platform = '';
        try {
            platform = (navigator.userAgentData && navigator.userAgentData.platform) ||
                       navigator.platform || '';
        } catch (e) {}
        return {
            device:    isTablet ? 'tablet' : (isMobile ? 'mobile' : 'desktop'),
            platform:  platform || null,
            lang:      ((navigator.language || '') + '').slice(0, 8) || null,
            screen_w:  (window.screen && window.screen.width)  || null,
            screen_h:  (window.screen && window.screen.height) || null,
            viewport_w: window.innerWidth  || null,
            viewport_h: window.innerHeight || null,
            ua:        ua.slice(0, 255)
        };
    }
    function captureUtm() {
        try {
            var existing = sessionStorage.getItem(UTM_KEY);
            if (existing) return JSON.parse(existing);
        } catch (e) {}
        var params;
        try { params = new URLSearchParams(location.search || ''); } catch (e) { params = null; }
        function p(k) { try { return params ? (params.get(k) || null) : null; } catch (e) { return null; } }
        var utm = {
            source:   p('utm_source'),
            medium:   p('utm_medium'),
            campaign: p('utm_campaign'),
            term:     p('utm_term'),
            content:  p('utm_content')
        };
        try { sessionStorage.setItem(UTM_KEY, JSON.stringify(utm)); } catch (e) {}
        return utm;
    }
    function captureEntry() {
        try {
            var existing = sessionStorage.getItem(ENTRY_KEY);
            if (existing) return JSON.parse(existing);
        } catch (e) {}
        var entry = {
            page:     location.pathname,
            search:   location.search || '',
            referrer: document.referrer || null,
            ts:       Date.now()
        };
        try { sessionStorage.setItem(ENTRY_KEY, JSON.stringify(entry)); } catch (e) {}
        return entry;
    }
    function getCountry() {
        try { return localStorage.getItem('country') || null; } catch (e) { return null; }
    }

    /* ============================================================
       Card / product helpers
       ============================================================ */

    function closestCard(el) {
        while (el && el !== document.body) {
            if (el.nodeType === 1) {
                if (el.tagName && el.tagName.toLowerCase() === 'product-card') return el;
                if (el.classList && el.classList.contains('product-card'))      return el;
            }
            el = el.parentNode;
        }
        return null;
    }
    function cardPosition(card) {
        try {
            if (!card || !card.closest) return null;
            // Reco rails (<product-recommendations>) carry no grid position.
            if (card.closest('product-recommendations')) return null;
            // CONTINUOUS ACROSS THE PAGE: a "sub collection" is just a second
            // <product-list>, NOT a reason to restart at 1. Index this card among
            // ALL collection-grid cards on the page (every <product-list>), in
            // document order, skipping reco rails — so a second block reads
            // …12, 13, 14 rather than resetting. (Earlier this scoped to the
            // card's own <product-list>, which restarted each block at 1.)
            // 1-based: first grid card is position 1. Single source for every
            // card_position + referrer_card_position emitted by this client.
            var all = document.querySelectorAll('product-list product-card, product-list .product-card');
            if (!all || !all.length) return null;
            var pos = 0;
            for (var i = 0; i < all.length; i++) {
                if (all[i].closest('product-recommendations')) continue; // skip reco cards in the count
                pos++;
                if (all[i] === card) return pos;
            }
        } catch (e) {}
        return null;
    }
    // Pagination page for grid-card events. The collection theme uses classic
    // {% paginate %} with facet-link pagination: changing page REPLACES the
    // <product-list> and rewrites the URL to ?page=N, so cardPosition() restarts
    // at 1 on each page. Emit the page ALONGSIDE card_position so position is
    // unambiguous across pages (page 2 / position 1 != page 1 / position 1).
    // Read from the URL at emit time — correct on initial load, a direct
    // ?page=N link, AND after a facet-link AJAX page change (which rewrites it).
    // No ?page (page 1 / non-collection grids) -> 1.
    function currentPage() {
        try {
            var p = parseInt(new URLSearchParams(location.search).get('page') || '1', 10);
            return (isFinite(p) && p > 0) ? p : 1;
        } catch (e) { return 1; }
    }
    // Translate the engine's opaque DOM stamp (data-low-stock-source) into the
    // readable analytics names. The engine keeps stamping short codes on the DOM
    // (a=real, b=synthetic, c=returning reco) — opaque so the DOM itself never
    // leaks the synthetic nature; priority-products stamps 'best-seller'. We map
    // to readable names ONLY here (observer-side) so the engine's DOM + persisted
    // state stay untouched. NB: `.badge--low-stock` is a JS-ONLY class (verified:
    // no Liquid renders it) — so EVERY such badge is ours and SHOULD carry a stamp.
    // A present badge with NO stamp is therefore an anomaly (our paint missed it),
    // labelled 'unknown' — there is no theme/merchant badge using this class.
    function mapBadgeSource(raw) {
        switch (raw) {
            case 'a': return 'stocks';       // genuine Shopify inventory low (real)
            case 'b': return 'engine';       // synthetic / engine lifecycle
            case 'c': return 'return_reco';  // returning predicted-next reco (engine grid + priority-products teaser)
            case 'd': return 'best';         // best-seller (priority-products teaser + best-seller-collection toast)
            // Descriptive aliases — defensive fallback for any pre-neutralization stamp still in the wild:
            case 'best-seller': case 'best-seller-collection': return 'best';
            case 'predicted-next': return 'return_reco';
            case null: case undefined: case '': return 'unknown'; // anomaly: our badge missing its stamp

            default: return raw;             // already a readable name / future code
        }
    }
    // Resolve a product handle from a card as ROBUSTLY as possible: the
    // `handle`/`data-handle` attribute, a child carrying `data-handle`, or the
    // product link's /products/<handle> href. The href fallback is universal
    // (every product card links to its PDP), so cards whose handle isn't a direct
    // attribute — or hasn't hydrated yet — still resolve. This is the #1 reason
    // card_impression (and card_seen/card_click) was missing for some cards.
    function _cardHandle(card) {
        try {
            if (!card) return null;
            var h = card.getAttribute && (card.getAttribute('handle') || card.getAttribute('data-handle'));
            if (h) return h;
            var withData = card.querySelector && card.querySelector('[data-handle]');
            if (withData) { h = withData.getAttribute('data-handle'); if (h) return h; }
            var link = card.querySelector && card.querySelector('a[href*="/products/"]');
            if (link) {
                var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
                if (m && m[1]) return decodeURIComponent(m[1]);
            }
        } catch (e) {}
        return null;
    }
    // Mirror the engine's authoritative low-stock-badge detector
    // (agb-variant-extension `_cardAlreadyHasLowStockBadge`): the JS-only
    // `.badge--low-stock` class first, else ANY `.badge` whose text reads
    // "LOW STOCK" / "LOW ON STOCK" — so cae's had_low_badge stays in lockstep with
    // what the engine itself counts as a low-stock badge.
    function _cardLowStockBadge(card) {
        try {
            if (!card || !card.querySelector) return null;
            var b = card.querySelector('.badge--low-stock');
            if (b) return b;
            var badges = card.querySelectorAll('.badge');
            for (var i = 0; i < badges.length; i++) {
                var t = (badges[i].textContent || '').trim().toUpperCase();
                if (t === 'LOW STOCK' || t === 'LOW ON STOCK') return badges[i];
            }
        } catch (e) {}
        return null;
    }
    // Panel-configured "Custom Label" (formerly the "ACO Labeller" — NEW /
    // SALE / etc), a DIFFERENT badge from the scarcity "LOW ON STOCK" one. It
    // renders as <span class="badge custom-label" data-custom-label-<id>="1">;
    // the per-label id is encoded in the attribute NAME (custom-labels.js
    // _badgeDataAttr). Reported on events SEPARATELY from the low-stock badge.
    // DUAL-READ both the new ('custom-label' / 'data-custom-label-') and the
    // legacy ('aco-label' / 'data-aco-label-') class+attr so detection works
    // regardless of which theme version is live during the rename rollout.
    function _cardCustomLabelBadge(card) {
        try {
            if (!card || !card.querySelector) return null;
            var b = card.querySelector('.custom-label, .aco-label');
            if (b) return b;
            // Fallback: any badge element carrying a data-(custom|aco)-label-* attr.
            var badges = card.querySelectorAll('.badge');
            for (var i = 0; i < badges.length; i++) {
                if (_customLabelId(badges[i])) return badges[i];
            }
        } catch (e) {}
        return null;
    }
    // Stable per-label id, parsed out of the data-custom-label-<id> (or legacy
    // data-aco-label-<id>) attribute name (skips the *-name text attr). Lets
    // events carry WHICH panel label fired, not just that one did.
    function _customLabelId(el) {
        try {
            if (!el || !el.attributes) return null;
            for (var i = 0; i < el.attributes.length; i++) {
                var n = el.attributes[i].name;
                if (n.indexOf('data-custom-label-') === 0 && n !== 'data-custom-label-name') {
                    return n.slice('data-custom-label-'.length) || null;
                }
                if (n.indexOf('data-aco-label-') === 0 && n !== 'data-aco-label-name') {
                    return n.slice('data-aco-label-'.length) || null;
                }
            }
        } catch (e) {}
        return null;
    }
    // Human-readable label: visible text, else image alt, else the stamped name.
    function _customLabelText(el) {
        try {
            if (!el) return null;
            var t = (el.textContent || '').trim();
            if (t) return t;
            var img = el.querySelector && el.querySelector('img');
            if (img && img.alt && img.alt.trim()) return img.alt.trim();
            var nm = (el.getAttribute && (el.getAttribute('data-custom-label-name') || el.getAttribute('data-aco-label-name'))) || '';
            return nm.trim() ? nm.trim() : null;
        } catch (e) {}
        return null;
    }
    function cardContext(card) {
        if (!card) return null;
        var handle = _cardHandle(card);
        var badge  = _cardLowStockBadge(card);
        var rawSrc = (badge && badge.dataset) ? badge.dataset.lowStockSource : null;
        // Engagement suffix: the engine stamps data-low-stock-clicked='1' on
        // synthetic-LIFECYCLE badges (the shopper clicked into the product);
        // grid teasers / best-seller / real-stock leave it unset (passive). So
        // a passive 'return_reco' teaser is distinguishable from a clicked
        // 'return_reco_clicked' lifecycle badge.
        var clicked = !!(badge && badge.dataset && badge.dataset.lowStockClicked === '1');
        // Detect the panel/Custom-Label badge INDEPENDENTLY of the low-stock
        // badge: a card can show BOTH (e.g. a best-seller that's ALSO on a Custom
        // Label). had_low_badge and had_panel_badge are separate booleans, so
        // report each truthfully — don't suppress the label just because a
        // low-stock badge is present (that hid Custom Labels on best-seller cards).
        var cl = _cardCustomLabelBadge(card);
        return {
            handle:       handle || null,
            position:     cardPosition(card),
            // had_low_badge stays SCARCITY-ONLY (don't inflate low-stock metrics);
            // the panel badge gets its own had_panel_badge flag.
            had_low_badge:    !!badge,
            // Readable source (mapBadgeSource): stocks / engine / return_reco /
            // best / unknown — with a '_clicked' suffix when engagement-activated.
            // null only when there's no low-stock badge.
            low_badge_source: badge ? (mapBadgeSource(rawSrc) + (clicked ? '_clicked' : '')) : null,
            // Panel-configured Custom Label, reported separately.
            had_panel_badge: !!cl,
            // The panel label's text + stable id (null unless a custom label shows).
            // (badge_kind dropped 2026-06-22 — redundant: it's 'lowstock' when
            // had_low_badge, else 'custom' when had_panel_badge; derive in SQL.)
            badge_label:    cl ? _customLabelText(cl) : null,
            badge_label_id: cl ? _customLabelId(cl)   : null
        };
    }
    function collectionContext() {
        return {
            id:     window.__currentCollectionId     || null,
            handle: window.__currentCollectionHandle || null
        };
    }
    // The engine keeps a per-PDP record of what it actually painted:
    // handle -> { mode, variantId, count }. `mode` is the ONLY place it says
    // WHICH of its two mutually exclusive paths produced the on-screen number,
    // using the same opaque codes the DOM badge carries ('a' = genuine Shopify
    // inventory, 'b' = the engine's own lifecycle). getSignalStatus() cannot
    // answer that question: it only ever describes a lifecycle. We read the
    // record here, observer-side, so the engine stays untouched.
    function readEngineDisplayMode(handle, variantId) {
        try {
            var map = window.SE_Engine && window.SE_Engine.pdpLowStockState;
            if (!map || typeof map !== 'object') return null;
            var st = handle ? map[handle] : null;
            if (!st || !st.mode) return null;
            // The record is keyed per product but describes ONE variant. Trust it
            // only for that variant — a caller asking about a different variant
            // gets nothing rather than a guess. Callers that name no variant (the
            // grid) fall through to the handle-level record, which on a collection
            // page is empty anyway: the map is in-memory and PDP-only.
            if (variantId != null && String(st.variantId) !== String(variantId)) return null;
            return st;
        } catch (e) { return null; }
    }
    function readUrgencyState(handle, variantId) {
        try {
            if (!window.SE_Engine || typeof window.SE_Engine.getSignalStatus !== 'function') {
                return null;
            }
            var s = window.SE_Engine.getSignalStatus(handle, variantId);
            var disp = readEngineDisplayMode(handle, variantId);
            // `src`: opaque numeric origin code for analytics segmentation.
            // Neutral on purpose — this payload is shopper-visible (DevTools →
            // Network), so it must NOT carry a real/fake field name. Keep neutral.
            // Trust the record only when this row names a variant, so it can be
            // matched against the one the engine painted. A caller that names no
            // variant (the collection grid) gets nothing: a card's badge origin is
            // already reported on its own field, and reading a handle-level record
            // there would guess from a PDP paint that belongs to another surface.
            var dispSrc = (disp && variantId != null)
                          ? (disp.mode === 'a' ? 1 : (disp.mode === 'b' ? 2 : null))
                          : null;
            if (!s) {
                // No lifecycle. That used to mean "no urgency", full stop — which
                // silently swallowed every genuine-inventory exposure: that path
                // shows its "only N left" and deliberately never seeds a lifecycle,
                // so src could never be 1. When the engine says it painted THIS
                // variant from genuine inventory, report the exposure.
                if (dispSrc === 1) {
                    return {
                        had_urgency: true,
                        count:       (typeof disp.count === 'number') ? disp.count : null,
                        src:         1
                    };
                }
                return { had_urgency: false };
            }
            // A genuine paint recorded for THIS variant counts as urgency on its
            // own, exactly as it does in the no-lifecycle branch above. Without
            // this, a lifecycle whose count has bottomed out reports "no urgency"
            // while still carrying the genuine number below it, so the row would
            // contradict itself and the exposure would go unrecorded.
            var hadUrg = !!(s.count || s.isReal || s.shouldShow) || dispSrc === 1;
            // A lifecycle can keep ticking on a product whose stock has since
            // fallen low for real; the PDP then shows the genuine number and the
            // lifecycle one is not on screen. Report what the shopper saw.
            var count = (typeof s.count === 'number') ? s.count : null;
            if (dispSrc === 1 && typeof disp.count === 'number') count = disp.count;
            return {
                had_urgency: hadUrg,
                count:       count,
                src:         hadUrg ? (dispSrc != null ? dispSrc : (s.isReal ? 1 : 2)) : null
            };
        } catch (e) { return null; }
    }
    function readVariantContext(handle) {
        try {
            var picker = document.querySelector('variant-picker[handle="' + handle + '"]') ||
                         document.querySelector('variant-picker') ||
                         null;
            if (!picker) return null;
            var dataEl = picker.querySelector('[data-product-variants-json]');
            var variants = dataEl ? JSON.parse(dataEl.textContent || dataEl.innerText || '[]') : [];
            var url = new URL(location.href);
            var vidStr = url.searchParams.get('variant');
            var currentId = vidStr ? Number(vidStr) : null;
            var defaultId = variants.length ? Number(variants[0].id) : null;
            return {
                variant_id:         currentId || defaultId,
                variant_is_default: (currentId == null) || (currentId === defaultId),
                inventory_quantity: null
            };
        } catch (e) { return null; }
    }
    // is_default for an ADDED variant: true/false only when the added variant is
    // one of THIS product's picker variants (i.e. we're on its PDP, comparing to
    // variants[0] = Shopify's default — same source as readVariantContext above);
    // null otherwise (collection quick-add / gear-builder accessory / cross-page),
    // since we can't know another product's default. Never undefined.
    function _resolveIsDefault(handle, variantId) {
        try {
            if (variantId == null) return null;
            var picker = (handle && document.querySelector('variant-picker[handle="' + handle + '"]')) ||
                         document.querySelector('variant-picker') || null;
            var dataEl = picker && picker.querySelector('[data-product-variants-json]');
            if (!dataEl) return null;
            var variants = JSON.parse(dataEl.textContent || dataEl.innerText || '[]');
            if (!variants.length) return null;
            var vid = Number(variantId);
            var known = variants.some(function (v) { return Number(v.id) === vid; });
            if (!known) return null; // not this product's variant → can't judge its default
            return vid === Number(variants[0].id);
        } catch (e) { return null; }
    }

    /* ============================================================
       Queue / transport
       ============================================================ */

    function loadQueue() {
        try {
            var raw = localStorage.getItem(QUEUE_KEY);
            var arr = raw ? JSON.parse(raw) : [];
            return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
    }
    function saveQueue(arr) {
        try {
            var trimmed = (arr.length > MAX_QUEUE) ? arr.slice(-MAX_QUEUE) : arr;
            localStorage.setItem(QUEUE_KEY, JSON.stringify(trimmed));
        } catch (e) { /* quota or private mode — accept loss */ }
    }
    function removeQueuedByIds(ids) {
        if (!ids || !ids.length) return;
        var idSet = Object.create(null);
        for (var i = 0; i < ids.length; i++) idSet[ids[i]] = true;
        var remaining = loadQueue().filter(function (ev) { return !idSet[ev.eventId]; });
        saveQueue(remaining);
    }

    function buildPulse(events) {
        return {
            type: PULSE_TYPE,
            schemaVersion: SCHEMA_VERSION,
            sentAt: new Date().toISOString(),
            sessionId: getSessionId(),
            sessionStartedAt: new Date(getSessionStartMs()).toISOString(),
            viewerId: getViewerId(),
            site: location.host,
            path: location.pathname + (location.search || ''),
            referrer: document.referrer || null,
            state: {
                utm:     captureUtm(),
                entry:   captureEntry(),
                device:  deviceContext(),
                country: getCountry(),
                page_type: pageType()
            },
            events: events
        };
    }

    var inflight = false;
    var inflightIds = null;   // eventIds riding in the current keepalive fetch
    function flush(opts) {
        opts = opts || {};
        if (!ENDPOINT) return;
        if (inflight && !opts.force) return;

        if (opts.useBeacon && navigator.sendBeacon) {
            // The page is going away: send the WHOLE queue, batch after batch,
            // not just the first 50 - the rest used to wait in localStorage until
            // the shopper came back (events arrived up to ~8 days late) or never.
            // Stop the moment the browser refuses a beacon (its in-flight budget,
            // ~64 KB, shared with keepalive fetches, is spent); whatever is left
            // goes out on the next page. Events already riding in a keepalive
            // fetch are skipped - that fetch outlives the page, and sending them
            // twice used up the budget the tail needed (review of 283eb9c).
            try {
                for (var round = 0; round < MAX_EXIT_BATCHES; round++) {
                    var pendingQ = loadQueue().filter(function (ev) { return !(inflightIds && inflightIds[ev.eventId]); });
                    if (!pendingQ.length) break;
                    var bb = pendingQ.slice(0, BATCH_SIZE), bids = [];
                    for (var j = 0; j < bb.length; j++) bids.push(bb[j].eventId);
                    var ok = navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify(buildPulse(bb))], { type: 'application/json' }));
                    log('beacon', ok ? 'ok' : 'refused', bids.length);
                    if (!ok) break;
                    removeQueuedByIds(bids);
                }
            } catch (e) { warn('beacon threw', e); }
            return;
        }

        var q = loadQueue();
        if (!q.length) return;

        var batch = q.slice(0, BATCH_SIZE);
        var ids = [];
        for (var i = 0; i < batch.length; i++) ids.push(batch[i].eventId);

        var body;
        try { body = JSON.stringify(buildPulse(batch)); }
        catch (e) { warn('flush: stringify failed', e); return; }

        inflight = true;
        inflightIds = Object.create(null);
        for (var k = 0; k < ids.length; k++) inflightIds[ids[k]] = true;
        try {
            fetch(ENDPOINT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: body,
                mode: 'cors',
                credentials: 'omit',
                keepalive: true
            }).then(function (res) {
                if (res && res.ok) {
                    removeQueuedByIds(ids);
                    log('flush ok', ids.length);
                } else if (res && res.status >= 400 && res.status < 500) {
                    removeQueuedByIds(ids);
                    warn('flush 4xx, dropped', res.status);
                } else {
                    warn('flush non-2xx, will retry', res && res.status);
                }
            }).catch(function (err) {
                warn('flush network error, will retry', err);
            }).then(function () { inflight = false; inflightIds = null; });
        } catch (e) {
            inflight = false;
            inflightIds = null;
            warn('flush threw', e);
        }
    }

    /* ============================================================
       Emit
       ============================================================ */

    // Dorian 2026-11-04: "Make the simulation of a real user also create logs". A test
    // customer on a PREVIEW theme records like anyone: the ingest tags its rows internal
    // from the facade00- id, so events_dedup and every report
    // leave them out, and Isaiah's Storytelling > Website changes reads them. On the
    // live theme a test customer stays silent, as before.
    function simulationRecords() {
        var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
        if (!role || role === 'main') return false;
        return String(getViewerId() || '').indexOf('facade00-') === 0;
    }

    function emit(eventName, detail) {
        // Fake Customer Engine: a synthetic visitor emits NO analytics (drop
        // events entirely). Nothing is queued here, so nothing is ever sent.
        // Except on a preview, where its visit is the log (simulationRecords).
        try { if (window.SE_isInternalSession && window.SE_isInternalSession() && !simulationRecords()) return null; } catch (e) {}
        if (AUTOMATED) return null;   // crawler / automation: not a shopper (see AUTOMATED_UA_RE)
        try {
            var ev = {
                eventId:     createUuid(),
                eventName:   eventName,
                createdAt:   new Date().toISOString(),
                createdAtMs: Date.now(),
                sessionId:   getSessionId(),
                viewerId:    getViewerId(),
                page: {
                    path:   location.pathname,
                    search: location.search || '',
                    title:  document.title || ''
                },
                detail: detail || {}
            };
            var q = loadQueue();
            q.push(ev);
            if (q.length > MAX_QUEUE) q = q.slice(-MAX_QUEUE);
            saveQueue(q);
            // Not while the page is leaving: the exit handler is about to beacon
            // the whole queue, and a keepalive fetch started here would send the
            // same 50 events twice out of the same ~64 KB budget.
            if (q.length >= BATCH_SIZE && !EXITING) flush({});
            log('emit', eventName, detail);
            return ev;
        } catch (e) { warn('emit threw', e); return null; }
    }

    /* ============================================================
       Event 1: session_start — once per session
       ============================================================ */

    function emitSessionStartOnce() {
        try {
            if (sessionStorage.getItem(SESSION_START_FIRED_KEY) === '1') return;
        } catch (e) {}
        var dev = deviceContext();
        emit('session_start', {
            utm:         captureUtm(),
            entry:       captureEntry(),
            device:      dev.device,
            platform:    dev.platform,
            lang:        dev.lang,
            screen_w:    dev.screen_w,
            screen_h:    dev.screen_h,
            viewport_w:  dev.viewport_w,
            viewport_h:  dev.viewport_h,
            country:     getCountry(),
            page_type:   pageType()
        });
        try { sessionStorage.setItem(SESSION_START_FIRED_KEY, '1'); } catch (e) {}
    }

    /* ============================================================
       Event 2: page_view — every page load
       ============================================================ */

    // HOW THE PAGE WAS REACHED. One page view in five followed another with no
    // click before it (ROW, 7 days to 2026-09-09) and the story read "arrived
    // without the click that took them there". Most of those are the browser's
    // own navigations: Back / Forward, a reload, or a page RESTORED from the
    // back-forward cache - which fires no load at all, so no page_view was
    // emitted and a third of mobile card clicks landed "on" a page the story
    // had never shown the shopper returning to. `nav_type` names the first
    // three from the Navigation Timing entry; 'bfcache' is the restore, emitted
    // from pageshow below.
    function navigationType() {
        try {
            var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
            if (entries && entries[0] && entries[0].type) return String(entries[0].type);
            var legacy = performance.navigation && performance.navigation.type;
            if (legacy === 1) return 'reload';
            if (legacy === 2) return 'back_forward';
            if (legacy === 0) return 'navigate';
        } catch (e) {}
        return null;
    }

    // A DEFERRED PAGE VIEW THAT NEVER FIRED IS A LANDING NOBODY RECORDED.
    // The product branch below waits 1.2 s for the variant and urgency state to
    // settle before it emits; emit() is the only thing that queues, so a shopper
    // who leaves inside that window leaves NOTHING - not the product, not even
    // the fact that they were here, and the unload beacon has nothing to send.
    // Measured on ROW 2026-09-09 (7 days, events_dedup): 22.8% of sessions that
    // LAND on a product page emit no page_view at all, against 2.7% of every
    // other landing - the shortest product visits, exactly the ones a bounce
    // rate is made of, were missing from the warehouse. So the deferred send is
    // parked here and the unload handlers fire it first, with whatever context
    // has settled by then (marked `left_early`).
    var pendingPageView = null;
    function sendPendingPageView() {
        var send = pendingPageView;
        if (send) { try { send(true); } catch (e) {} }
    }

    function emitPageView(navType) {
        var base = {
            page_type: pageType(),
            referrer:  document.referrer || null,
            nav_type:  navType || navigationType(),
            time_since_session_start_ms: Date.now() - getSessionStartMs()
        };
        if (navType === 'bfcache') base.restored = true;
        // Non-product pages: the plain page_view (unchanged).
        if (pageType() !== 'product') {
            emit('page_view', base);
            return;
        }
        // Product pages (#7): fold the former pdp_view detail INTO page_view so one
        // event carries page + product detail (no separate pdp_view). Deferred ~1.2s
        // — the same delay the old pdp_view used so urgency/variant settle after the
        // engine boots and any ?variant pre-select lands.
        function send(early) {
            pendingPageView = null;
            try {
                if (early) base.left_early = true;
                var m = location.pathname.match(/\/products\/([^\/\?]+)/);
                var handle = m ? m[1] : null;
                if (!handle) { emit('page_view', base); return; }

                var lastClick = null;
                try {
                    var raw = sessionStorage.getItem(LAST_CLICK_KEY);
                    if (raw) lastClick = JSON.parse(raw);
                } catch (e) {}
                var matchesLastClick = lastClick && lastClick.handle === handle;

                var variant = readVariantContext(handle) || {};
                var urg     = readUrgencyState(handle, variant.variant_id);

                base.product = { handle: handle };
                base.variant = { id: variant.variant_id || null, is_default: variant.variant_is_default };
                base.urgency = urg;
                base.referrer_card_position   = matchesLastClick ? lastClick.position   : null;
                base.referrer_page_number     = matchesLastClick ? (lastClick.page != null ? lastClick.page : null) : null;
                base.referrer_collection      = matchesLastClick ? lastClick.collection : null;
                base.time_since_card_click_ms = matchesLastClick && lastClick.ts ? (Date.now() - lastClick.ts) : null;
                emit('page_view', base);

                // Preserve the PDP-view marker add_to_cart reads for time_since_pdp_view_ms.
                try {
                    sessionStorage.setItem(LAST_PDP_VIEW_KEY, JSON.stringify({
                        handle: handle, variant_id: variant.variant_id || null, ts: Date.now()
                    }));
                } catch (e) {}
            } catch (err) { warn('page_view (product)', err); }
        }
        pendingPageView = send;
        // Only the pending send may fire: a rescued view has already gone.
        setTimeout(function () { if (pendingPageView === send) send(false); }, 1200);
    }

    /* ============================================================
       Event 3 + 4: card_seen, card_impression
       ============================================================ */

    var impressionLastTs = Object.create(null);
    var impressionScheduled = Object.create(null);
    var IMPRESSION_RENDER_DELAY_MS = 1200; // let the low-stock badge sweep + layout settle

    // card_impression = "card RENDERED on the page": fires ONCE per product when its
    // card is present in the grid, REGARDLESS of scroll — so it counts EVERY product
    // displayed. This is DISTINCT from card_seen, which fires only when a card scrolls
    // into the viewport (≥50% for SEEN_VISIBLE_MS = viewability). So impressions ≥ seens,
    // and seen/impression = how far shoppers actually scroll. Deferred ~1.2s after the
    // card attaches so the engine's low-stock badge sweep has painted (accurate
    // had_low_badge) and layout has settled (accurate card_position). impressionLastTs
    // doubles as the per-handle dedup AND card_click's time_since_impression_ms
    // ("time since the card was first shown").
    function _fireCardImpression(card, handle) {
        try {
            // Handle resolved at schedule time + passed in; fall back to a fresh
            // resolve. Once we KNOW the handle we emit even if the rest of the
            // context degraded (card re-rendered/detached) — the handle is the
            // load-bearing field, position/badge are best-effort + nullable.
            var h = handle || _cardHandle(card);
            if (!h) return;
            if (impressionLastTs[h]) return; // once per product per page
            impressionLastTs[h] = Date.now();
            var ctx = cardContext(card) || {};
            emit('card_impression', {
                product:       { handle: h },
                collection:    collectionContext(),
                card_position: (ctx.position != null ? ctx.position : null),
                page_number:   currentPage(),
                had_low_badge:     !!ctx.had_low_badge,
                low_badge_source:  ctx.had_low_badge ? (ctx.low_badge_source || 'unknown') : null,
                // Panel Custom Label, reported distinctly from low-stock.
                had_panel_badge: !!ctx.had_panel_badge,
                badge_label:   ctx.badge_label || null,
                badge_label_id: ctx.badge_label_id || null,
                urgency:       readUrgencyState(h, null)
            });
        } catch (e) { warn('card_impression', e); }
    }
    function _scheduleCardImpression(card, attempt) {
        try {
            attempt = attempt || 0;
            var h = _cardHandle(card);
            if (!h) {
                // The card may hydrate its handle a beat after insertion — retry a
                // few times before giving up, so late-hydrated cards still fire.
                if (attempt < 5 && card && card.isConnected !== false) {
                    setTimeout(function () { _scheduleCardImpression(card, attempt + 1); }, 400);
                }
                return;
            }
            if (impressionScheduled[h] || impressionLastTs[h]) return;
            var pending = {
                card: card,
                heldSeen: null,
                timer: setTimeout(function () {
                    impressionScheduled[h] = true;   // fired: stays set, like before
                    _fireCardImpression(card, h);
                    if (pending.heldSeen) emit('card_seen', pending.heldSeen);
                }, IMPRESSION_RENDER_DELAY_MS)
            };
            impressionScheduled[h] = pending;
        } catch (e) {}
    }

    // A card's impression must never trail - or go missing behind - its card_seen.
    // The 1.2 s render delay (above) is longer than card_seen's 0.5 s viewability
    // window, so on ROW 2026-09-24 (7 days) 18.5% of cards reported seen BEFORE
    // loaded, and every page closed between 0.5 s and 1.2 s kept its seens and
    // lost its loads (4,155 sessions with seens and no load at all). So:
    //  - a card_seen that arrives while its impression is still waiting is HELD
    //    on the pending entry and sent right after the impression - the
    //    impression keeps its 1.2 s badge snapshot (the engine often paints the
    //    LOW STOCK badge between 0.5 s and 1.2 s; firing the impression early
    //    lost the badge on ~2% of badged cards - review of 283eb9c);
    //  - leaving the page (and a click) fires the pending impression - and its
    //    held seen - at once (_fireImpressionNow / fireAllPendingImpressions):
    //    the cards WERE rendered.
    function _fireImpressionNow(h, cardFallback) {
        try {
            if (!h || impressionLastTs[h]) return;
            var pending = impressionScheduled[h];
            if (pending && pending.timer) clearTimeout(pending.timer);
            impressionScheduled[h] = true;
            _fireCardImpression((pending && pending.card) || cardFallback, h);
            if (pending && pending.heldSeen) emit('card_seen', pending.heldSeen);
        } catch (e) {}
    }
    function fireAllPendingImpressions() {
        try {
            for (var h in impressionScheduled) {
                if (impressionScheduled[h] && impressionScheduled[h].timer) _fireImpressionNow(h);
            }
        } catch (e) {}
    }

    var seenFired   = Object.create(null);
    var seenPending = Object.create(null);

    // (Late-painting-badge fire-and-correct watcher REMOVED 2026-06-22 — the
    // `card_low_badge_late` corrective event is no longer collected. card_seen /
    // card_impression now report had_low_badge as-of emit time only.)

    function installCardSeenObserver() {
        if (!window.IntersectionObserver) return null;
        var observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                var entry = entries[i];
                var card  = entry.target;
                var ctx   = cardContext(card);
                if (!ctx || !ctx.handle) continue;

                if (entry.intersectionRatio >= SEEN_VISIBLE_RATIO) {
                    if (seenFired[ctx.handle] || seenPending[ctx.handle]) continue;
                    (function (c, cardRef) {
                        seenPending[c.handle] = setTimeout(function () {
                            seenPending[c.handle] = null;
                            if (seenFired[c.handle]) return;
                            seenFired[c.handle] = true;
                            // Emit card_seen PROMPTLY (no delay, never lost on
                            // page-leave). had_low_badge reflects the badge state at the
                            // moment the card was seen, read with the engine-mirrored
                            // detector (_cardLowStockBadge: the `.badge--low-stock`
                            // class OR any `.badge` reading "LOW (ON) STOCK").
                            var fresh = cardContext(cardRef) || c;
                            var seenDetail = {
                                product:       { handle: fresh.handle },
                                collection:    collectionContext(),
                                card_position: fresh.position,
                                page_number:   currentPage(),
                                had_low_badge:     fresh.had_low_badge,
                                low_badge_source:  fresh.low_badge_source,
                                // Panel Custom Label, reported distinctly.
                                had_panel_badge: !!fresh.had_panel_badge,
                                badge_label:   fresh.badge_label || null,
                                badge_label_id: fresh.badge_label_id || null
                            };
                            // Loaded before seen, always (see _fireImpressionNow):
                            // hold the seen while the load waits on its render delay,
                            // else make sure the load exists, then send the seen.
                            var hk = fresh.handle || c.handle;
                            var waiting = impressionScheduled[hk];
                            if (waiting && waiting.timer) {
                                waiting.heldSeen = seenDetail;
                            } else {
                                _fireImpressionNow(hk, cardRef);
                                emit('card_seen', seenDetail);
                            }
                            // card_impression is NOT emitted here — it fires on RENDER
                            // (every card in the grid) via _scheduleCardImpression, so it
                            // counts all products, not just the ones scrolled into view.
                            // card_seen is the viewport/viewability signal.
                        }, SEEN_VISIBLE_MS);
                    })(ctx, card);
                } else {
                    if (seenPending[ctx.handle]) {
                        clearTimeout(seenPending[ctx.handle]);
                        seenPending[ctx.handle] = null;
                    }
                }
            }
        }, { threshold: [0, SEEN_VISIBLE_RATIO, 1] });

        function attachCardsIn(root) {
            try {
                var cards = root.querySelectorAll('product-card, .product-card');
                for (var i = 0; i < cards.length; i++) {
                    observer.observe(cards[i]);          // viewport → card_seen
                    _scheduleCardImpression(cards[i]);   // rendered → card_impression
                }
            } catch (e) {}
        }
        attachCardsIn(document);
        if (window.MutationObserver) {
            var mo = new MutationObserver(function (mutations) {
                for (var mi = 0; mi < mutations.length; mi++) {
                    var m = mutations[mi];
                    for (var ni = 0; ni < m.addedNodes.length; ni++) {
                        var node = m.addedNodes[ni];
                        if (!node || node.nodeType !== 1) continue;
                        try {
                            if (node.matches && node.matches('product-card, .product-card')) {
                                observer.observe(node);
                                _scheduleCardImpression(node);
                            } else if (node.querySelectorAll) {
                                attachCardsIn(node);
                            }
                        } catch (e) {}
                    }
                }
            });
            mo.observe(document.body, { subtree: true, childList: true });
        }
        return observer;
    }

    /* ============================================================
       Event 5: card_click — delegated
       ============================================================ */

    function classifyClickTarget(el) {
        try {
            if (el.closest && el.closest('.product-card__quick-add-button')) return 'quick_add';
            if (el.closest && el.closest('.product-title'))                  return 'title_link';
            if (el.closest && el.closest('a.product-card__media'))           return 'media_link';
            if (el.closest && el.closest('a'))                               return 'link';
            if (el.closest && el.closest('button'))                          return 'button';
        } catch (e) {}
        return 'unknown';
    }

    function installCardClickDelegate() {
        document.addEventListener('click', function (e) {
            try {
                var t = e.target;
                if (!t || t.nodeType !== 1) return;
                var card = closestCard(t);
                if (!card) return;
                var isAction = (t.closest && (t.closest('a') || t.closest('button')));
                if (!isAction) return;

                var ctx = cardContext(card);
                if (!ctx || !ctx.handle) return;

                // A tap inside the first 0.5 s (before card_seen) must not come
                // before the card's load either: 1,547 of 52,795 clicks (7 days to
                // 2026-09-24) had no impression yet. Fires it (and a held seen) now.
                _fireImpressionNow(ctx.handle, card);
                var impressionTs = impressionLastTs[ctx.handle];
                var since = impressionTs ? (Date.now() - impressionTs) : null;

                emit('card_click', {
                    product:        { handle: ctx.handle },
                    collection:     collectionContext(),
                    card_position:  ctx.position,
                    page_number:    currentPage(),
                    had_low_badge_at_click: ctx.had_low_badge,
                    low_badge_source:   ctx.low_badge_source,
                    // Panel Custom Label present at click, reported distinctly.
                    had_panel_badge_at_click: !!ctx.had_panel_badge,
                    badge_label:    ctx.badge_label || null,
                    badge_label_id: ctx.badge_label_id || null,
                    click_target:   classifyClickTarget(t),
                    time_since_impression_ms: since
                });

                try {
                    sessionStorage.setItem(LAST_CLICK_KEY, JSON.stringify({
                        handle:     ctx.handle,
                        position:   ctx.position,
                        page:       currentPage(),
                        collection: collectionContext(),
                        ts:         Date.now()
                    }));
                } catch (e2) {}
            } catch (err) { warn('card click', err); }
        }, true);
    }

    /* ============================================================
       (pdp_view removed (#7) — its detail is folded into page_view on product
       pages; see emitPageView. The product-page page_view still writes
       LAST_PDP_VIEW_KEY so add_to_cart's time_since_pdp_view_ms keeps working.)
       ============================================================ */

    /* ============================================================
       Event 7: variant_change — theme 'variant:change', USER-INITIATED ONLY
       ============================================================ */

    // The theme re-dispatches 'variant:change' as a JS CustomEvent for BOTH
    // real swatch clicks AND programmatic selection (e.g. the scarcity engine's
    // _preSelectPredictedVariant force-switch, which dispatches change / clicks
    // a label). e.isTrusted is therefore false in BOTH cases — useless here.
    // Instead we stamp the last TRUSTED user interaction on a variant-picker
    // (capture phase; isTrusted=true ONLY for genuine user input — a JS
    // dispatchEvent or element.click() is untrusted) and emit variant_change
    // only when 'variant:change' follows a real user change within the window.
    // Result: automatic/programmatic variant switches are never tracked.
    var lastUserVariantTs = 0;
    var USER_VARIANT_WINDOW_MS = 1000;
    // ONE swatch click makes several systems re-dispatch 'variant:change' within
    // the user window (Prestige picker + AGB variant.js writing input[name=id] +
    // the scarcity engine's colour resolve), so the gate alone lets 5-6 identical
    // emits through. Collapse a burst for the SAME variant into ONE emit. NB: the
    // BQ event_id dedup only catches DELIVERY duplicates (Pub/Sub redelivery /
    // beacon resends) — it does NOT collapse distinct re-emits like these, so the
    // fix has to live here. Matches the dedup card_click / add_to_cart already have.
    var _lastVariantEmit = { id: null, ts: 0 };
    var VARIANT_DEDUP_MS = 1200;

    function installVariantChangeListener() {
        try {
            function _stampUserVariant(e) {
                try {
                    if (!e || !e.isTrusted) return;            // genuine user input only
                    var t = e.target;
                    if (t && t.closest && t.closest('variant-picker, .variant-picker')) {
                        lastUserVariantTs = Date.now();
                    }
                } catch (err) {}
            }
            // 'change' covers radio/select; 'click' covers swatch labels/buttons.
            // Both in capture phase so they run before the theme re-dispatch.
            document.addEventListener('change', _stampUserVariant, true);
            document.addEventListener('click', _stampUserVariant, true);

            window.addEventListener('variant:change', function (e) {
                try {
                    // Gate: only a real, recent user swatch change qualifies.
                    // Programmatic switches (no preceding trusted input) are skipped.
                    if (Date.now() - lastUserVariantTs > USER_VARIANT_WINDOW_MS) return;
                    var d = e && e.detail;
                    if (!d) return;
                    var handle    = d.handle  || (location.pathname.match(/\/products\/([^\/\?]+)/) || [])[1] || null;
                    var variantId = (d.variant && d.variant.id) || d.variantId || null;
                    // Collapse the multi-dispatch burst: same variant within the
                    // window = ONE emit (keeps the FIRST dispatch, which carries the
                    // complete payload; the re-dispatches drop inventory_quantity etc).
                    // A genuine change to a DIFFERENT variant updates the key and emits.
                    var _vNow = Date.now();
                    if (variantId && variantId === _lastVariantEmit.id && (_vNow - _lastVariantEmit.ts) < VARIANT_DEDUP_MS) return;
                    _lastVariantEmit = { id: variantId, ts: _vNow };
                    var urg       = readUrgencyState(handle, variantId);
                    // The theme's d.variant is resolved from the picker's hidden option
                    // inputs, whose COLOUR field is Liquid-defaulted to the first colour.
                    // On a SIZE-only change that colour input still holds the default, so
                    // d.variant.options reports the wrong colour (e.g. "Black" while
                    // "Multicam" is displayed). The engine's getSelectedColor() reads the
                    // actually-checked colour swatch from the DOM. CAE only READS it.
                    var displayedColour = null;
                    try {
                        if (window.SE_Engine && typeof window.SE_Engine.getSelectedColor === 'function') {
                            var picker = document.querySelector('variant-picker[handle="' + handle + '"]') ||
                                         document.querySelector('variant-picker') || null;
                            if (picker) displayedColour = window.SE_Engine.getSelectedColor(picker) || null;
                        }
                    } catch (e) { displayedColour = null; }
                    // Overlay the real selected colour onto options[0] (colour is option1
                    // across the AGB pickers). Only when the engine gave us a colour — null
                    // for size-only / no-colour products → leave the theme options as-is.
                    var rawOptions = (d.variant && d.variant.options) || null;
                    var options    = rawOptions;
                    if (displayedColour != null && rawOptions && rawOptions.length) {
                        options = rawOptions.slice();
                        options[0] = displayedColour;
                    }
                    emit('variant_change', {
                        product: { handle: handle },
                        variant: {
                            id:                  variantId,
                            available:           d.variant && d.variant.available,
                            inventory_quantity:  d.variant && d.variant.inventory_quantity,
                            options:             options,
                            colour:              (displayedColour != null) ? displayedColour : (rawOptions && rawOptions.length ? rawOptions[0] : null)
                        },
                        urgency: urg
                    });
                } catch (err) { warn('variant:change', err); }
            });
        } catch (e) {}
    }

    /* ============================================================
       Event 8: add_to_cart — variant:add (primary) + cart:change fallback
       ============================================================ */

    // ONE add surfaces via BOTH the /cart/add.js fetch observer AND the later
    // cart:change re-render — observed ~3.6s apart, so the old global 500ms gate
    // missed it (and worse, that gate also DROPPED multi-line "add all" loadouts
    // whose lines emit in a tight loop — only the first survived). Dedup on the
    // add identity (handle+variant) over a window wide enough to span the dual-
    // path lag. Distinct variants (the AGB base+accessories loadout) keep distinct
    // keys → each still emits exactly once. (As with variant_change, the BQ
    // event_id dedup can't help: these are distinct re-emits, not delivery dups.)
    var _lastAddEmit = { key: null, ts: 0 };
    var ADD_DEDUP_MS = 6000;
    // The /cart/add.js fetch observer and theme variant:add are RELIABLE — they
    // carry the actually-added line. The cart:change fallback is NOT: it only sees
    // post-add cart state and can't tell which line is new (it was picking
    // items[last] = a PRE-EXISTING item, double-emitting a WRONG product). So when
    // a reliable path just logged an add, the cart:change fallback stands down. It
    // then only emits for adds NO reliable path saw (AGB Storefront-API loadout
    // adds, which don't hit /cart/add.js).
    var _lastReliableAddTs = 0;
    var RELIABLE_ADD_WINDOW_MS = 5000;

    // Compact summary of the whole cart for the add_to_cart payload (chosen
    // shape: one event per product + the current cart's product array).
    function _cartSummary(cart) {
        try {
            if (!cart) return null;
            var items = cart.items || [];
            return {
                item_count:  cart.item_count || items.length || 0,
                value_cents: cart.total_price || 0,
                handles:     items.map(function (it) { return it && it.handle; }).filter(Boolean)
            };
        } catch (e) { return null; }
    }

    function emitAddToCart(source, payload, cart) {
        try {
            var now = Date.now();
            var handle    = payload.handle    || null;
            var variantId = payload.variantId || null;
            var _addKey   = String(handle) + '|' + String(variantId);
            if (_addKey === _lastAddEmit.key && (now - _lastAddEmit.ts) < ADD_DEDUP_MS) return;
            _lastAddEmit = { key: _addKey, ts: now };

            var qty       = payload.quantity  || null;
            var urg       = readUrgencyState(handle, variantId);

            var lastPdp = null;
            try {
                var raw = sessionStorage.getItem(LAST_PDP_VIEW_KEY);
                if (raw) lastPdp = JSON.parse(raw);
            } catch (e) {}
            var time_since_pdp = (lastPdp && lastPdp.handle === handle && lastPdp.ts)
                                 ? (now - lastPdp.ts) : null;

            var _isDefault = (payload.variant_is_default != null ? payload.variant_is_default : _resolveIsDefault(handle, variantId));
            var detail = {
                product:  { handle: handle },
                variant:  { id: variantId, is_default: _isDefault },
                quantity: qty,
                // `added` is ALWAYS present (2026-07-13): single-line adds carry a
                // 1-element array in the exact shape emitAddBatch uses, so consumers
                // never need "no added = single add" special-casing — added[] is the
                // complete list of lines this action added, main product included.
                added: [{ handle: handle, variant_id: variantId, quantity: qty || 1, is_default: _isDefault }],
                added_count: 1,
                source:   source,
                urgency:  urg,
                time_since_pdp_view_ms:     time_since_pdp,
                time_since_session_start_ms: now - getSessionStartMs()
            };

            // d.cart lags intermittently (right sometimes, wrong others), so ALWAYS
            // read the authoritative /cart.js for the cart summary; this also
            // refreshes _lastFullCart for checkout_click.
            _fetchCartThen(function (c) {
                detail.cart = _cartSummary(c);
                emit('add_to_cart', detail);
            });
        } catch (e) { warn('emitAddToCart', e); }
    }

    // Resolve a product handle for an add, never returning undefined (#5):
    //   1) explicit handle/product_handle on the line/payload
    //   2) the current /products/<handle> path (PDP / AGB page)
    //   3) the newly-added cart line's handle (last item in cart.items)
    function resolveAddHandle(line, cart) {
        try {
            if (line && (line.handle || line.product_handle)) return line.handle || line.product_handle;
            var m = (location.pathname || '').match(/\/products\/([^\/\?]+)/);
            if (m && m[1]) return m[1];
            var items = (cart && cart.items) || [];
            var last = items.length ? items[items.length - 1] : null;
            if (last && last.handle) return last.handle;
        } catch (e) {}
        return null;
    }
    // Shopify /cart/add.js returns either a single line object or { items: [...] }.
    function normalizeAddedLines(resJson) {
        if (!resJson) return [];
        if (Object.prototype.hasOwnProperty.call(resJson, 'items') && Array.isArray(resJson.items)) return resJson.items;
        if (resJson.id || resJson.variant_id) return [resJson];
        return [];
    }
    // A line auto-added by the Ticking Time Bomb promo (the free scorpion
    // patch) — NOT a shopper add_to_cart. TTB stamps the line-item property
    // `_ttb_promo='true'` (ticking-time-bomb.js addPatchToCart), which Shopify
    // echoes back on the /cart/add.js response we observe, so we can filter it
    // out here with zero new wiring. Suppressing it keeps the auto-add from
    // inflating add_to_cart analytics. NOTE: if TTB ever switches to a
    // 'variant:add' event / product form, that path would need the same guard.
    function _isTtbAutoAddLine(line) {
        try {
            var p = line && line.properties;
            if (!p) return false;
            var v = p._ttb_promo;
            return v === true || v === 'true' || v === '1' || v === 1;
        } catch (e) { return false; }
    }
    function emitAddFromLine(source, line, cart) {
        if (!line) return;
        if (_isTtbAutoAddLine(line)) return; // TTB free-patch auto-add — not a shopper action
        emitAddToCart(source, {
            handle:    resolveAddHandle(line, cart),
            variantId: line.variant_id || line.id || null,
            quantity:  line.quantity || 1
        }, cart);
    }
    // A SINGLE add action that added MULTIPLE lines at once — the gear-builder
    // "Add all" (base carrier + every checked accessory), or any batched
    // /cart/add.js { items:[...] }. Emit ONE add_to_cart carrying the full
    // `added` array, instead of one event per line (the bug being fixed).
    function emitAddBatch(source, lines, cart) {
        try {
            var clean = [];
            for (var i = 0; i < (lines || []).length; i++) {
                var ln = lines[i];
                if (!ln) continue;
                if (_isTtbAutoAddLine(ln)) continue; // never count a TTB free-patch line in a batch
                var _h = resolveAddHandle(ln, cart);
                var _v = ln.variant_id || ln.id || null;
                clean.push({
                    handle:     _h,
                    variant_id: _v,
                    quantity:   ln.quantity || 1,
                    is_default: _resolveIsDefault(_h, _v)
                });
            }
            if (!clean.length) return;
            if (clean.length === 1) { emitAddFromLine(source, lines[0], cart); return; } // not a batch

            var now = Date.now();
            // Dedup the whole batch (the fetch observer + the cart:change fallback
            // can both surface the same loadout add) on its sorted line set.
            var _batchKey = 'batch:' + clean.map(function (a) { return a.handle + '|' + a.variant_id; }).sort().join(',');
            if (_batchKey === _lastAddEmit.key && (now - _lastAddEmit.ts) < ADD_DEDUP_MS) return;
            _lastAddEmit = { key: _batchKey, ts: now };

            // Primary product = first line (the base carrier in a loadout) for the
            // flat product/variant fields; `added` carries the WHOLE loadout.
            var primary = clean[0];
            var detail = {
                product:     { handle: primary.handle },
                variant:     { id: primary.variant_id, is_default: primary.is_default },
                quantity:    primary.quantity,
                added:       clean,            // every line added in this one action
                added_count: clean.length,
                source:      source,
                urgency:     readUrgencyState(primary.handle, primary.variant_id),
                time_since_session_start_ms: now - getSessionStartMs()
            };
            // Always read the authoritative /cart.js (d.cart lags); refreshes cache.
            _fetchCartThen(function (c) {
                detail.cart = _cartSummary(c);
                emit('add_to_cart', detail);
            });
        } catch (e) { warn('emitAddBatch', e); }
    }

    // Parse the /cart/add.js REQUEST body → { <variant_id>: addedQty, __single: addedQty }.
    // Shopify's add RESPONSE returns the MERGED line total (e.g. 3 if you already
    // had 2 and added 1), but the event should report the DELTA the shopper just
    // added (1). The request body carries that delta. Handles the add formats
    // Prestige/AGB use: form-urlencoded string, JSON {id,quantity}, JSON
    // {items:[{id,quantity}]}, FormData, URLSearchParams. Missing quantity = 1
    // (Shopify default). Best-effort: returns {__single:null} on anything it
    // can't read, so callers fall back to the response quantity (no regression).
    function _addRequestQtyById(init) {
        var out = { __single: null };
        function n(q) { var v = parseInt(q, 10); return (v && v > 0) ? v : 1; }
        function fromPair(id, q) {
            var qty = n(q);
            if (id != null) out[String(id)] = qty;
            out.__single = qty;
        }
        try {
            var body = init && init.body;
            if (!body) return out;
            if (typeof FormData !== 'undefined' && body instanceof FormData) {
                fromPair(body.get('id'), body.get('quantity')); return out;
            }
            if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
                fromPair(body.get('id'), body.get('quantity')); return out;
            }
            if (typeof body === 'string') {
                var s = body.trim();
                if (s.charAt(0) === '{' || s.charAt(0) === '[') {
                    var data = null;
                    try { data = JSON.parse(s); } catch (e) { data = null; }
                    if (data) {
                        if (Array.isArray(data.items)) {
                            for (var i = 0; i < data.items.length; i++) {
                                var it = data.items[i]; if (!it || it.id == null) continue;
                                out[String(it.id)] = n(it.quantity);
                            }
                            if (data.items.length === 1 && data.items[0]) out.__single = n(data.items[0].quantity);
                        } else if (data.id != null) {
                            fromPair(data.id, data.quantity);
                        }
                        return out;
                    }
                }
                // form-urlencoded (id=…&quantity=…)
                try { var p = new URLSearchParams(s); if (p.get('id') != null || p.get('quantity') != null) fromPair(p.get('id'), p.get('quantity')); } catch (e) {}
            }
        } catch (e) {}
        return out;
    }
    // Override response line quantities (merged totals) with the added delta
    // from the request body, matched by variant id (single-line falls back to
    // __single). Leaves a line untouched if we couldn't read its delta.
    function _applyAddedDelta(lines, reqQty) {
        if (!reqQty) return lines;
        try {
            for (var i = 0; i < lines.length; i++) {
                var ln = lines[i]; if (!ln) continue;
                var vid = (ln.variant_id != null ? ln.variant_id : ln.id);
                var d = (vid != null && reqQty[String(vid)] != null) ? reqQty[String(vid)]
                      : (lines.length === 1 && reqQty.__single != null ? reqQty.__single : null);
                if (d != null) ln.quantity = d;
            }
        } catch (e) {}
        return lines;
    }

    function installAddToCartListeners() {
        // ---- Primary (#4): read-only fetch observer for POST /cart/add(.js) ----
        // The only signal common to ALL add paths: stock Prestige <product-form> (k19),
        // the AGB/bundle hand-rolled handler, and any future fetch-based add. Clone the
        // response so we never consume the body the page needs. Idempotent + chains over
        // any wrapper already installed (the engine wraps the same /cart/add via its own
        // __SE_cartAddWrapped guard).
        try {
            if (typeof window.fetch === 'function' && !window.fetch.__CAE_cartAddWrapped) {
                var _origFetch = window.fetch.bind(window);
                var _wrapped = function (input, init) {
                    var url = '', method = '';
                    try {
                        url = (typeof input === 'string') ? input : ((input && input.url) || '');
                        method = ((init && init.method) || (input && input.method) || 'GET');
                    } catch (e) {}
                    var p = _origFetch(input, init);
                    try {
                        var isAdd = method && String(method).toUpperCase() === 'POST' &&
                                    /\/cart\/add(\.js)?(\?|$)/.test(String(url));
                        if (isAdd && p && typeof p.then === 'function') {
                            var _reqQty = _addRequestQtyById(init); // the DELTA added, not the merged line total Shopify's response returns
                            p.then(function (res) {
                                try {
                                    if (!res || !res.ok || typeof res.clone !== 'function') return;
                                    res.clone().json().then(function (resJson) {
                                        try {
                                            var lines = _applyAddedDelta(normalizeAddedLines(resJson), _reqQty);
                                            if (lines.length) _lastReliableAddTs = Date.now(); // reliable path owns this add → fallback stands down
                                            // Multi-line add (gear-builder "Add all": base + accessories) → ONE
                                            // event with the full `added` array, not one event per line.
                                            if (lines.length > 1) emitAddBatch('cart_add_fetch', lines, null);
                                            else for (var i = 0; i < lines.length; i++) emitAddFromLine('cart_add_fetch', lines[i], null);
                                        } catch (e2) {}
                                    }).catch(function () {});
                                } catch (e1) {}
                            }).catch(function () {});
                        }
                    } catch (e) { /* never break a real request */ }
                    return p;
                };
                _wrapped.__CAE_cartAddWrapped = true;
                window.fetch = _wrapped;
            }
        } catch (e) { warn('cart_add fetch observer install', e); }

        // ---- Secondary: theme variant:add (stock Prestige product-form) ----
        // Detail = { items, cart, onSuccessDo } — NO handle, NO variant (#5). Resolve
        // from the items array (each line carries handle/variant_id). emitAddToCart's
        // debounce dedups vs the fetch observer above.
        try {
            window.addEventListener('variant:add', function (e) {
                try {
                    var d = e && e.detail;
                    if (!d) return;
                    _lastReliableAddTs = Date.now(); // reliable path owns this add → cart:change fallback stands down
                    var cart = d.cart || null;
                    var lines = Array.isArray(d.items) ? d.items : (d.item ? [d.item] : []);
                    if (lines.length > 1) {
                        emitAddBatch('variant:add', lines, cart); // loadout → ONE event with `added[]`
                    } else if (lines.length === 1) {
                        emitAddFromLine('variant:add', lines[0], cart);
                    } else {
                        emitAddToCart('variant:add', {
                            handle:    resolveAddHandle(d, cart),
                            variantId: (d.variant && d.variant.id) || d.variantId || null,
                            quantity:  d.quantity || 1
                        }, cart);
                    }
                } catch (err) { warn('variant:add', err); }
            });
        } catch (e) {}

        // ---- Tertiary: cart:change add fallback ----
        // Covers the theme's documentElement cart:change ('add'/'variant:add') AND the
        // AGB section's document.dispatchEvent cart:change which has NO baseEvent and
        // does not bubble to window. Listen on BOTH window and document.
        function _onCartChangeAdd(e) {
            try {
                // A reliable path (fetch observer / variant:add) just logged this
                // add with the CORRECT line — stand down. Otherwise we double-emit
                // AND mis-report: cart:change can't identify the new line, so it was
                // surfacing a PRE-EXISTING cart item (items[last]) as the "add".
                if (Date.now() - _lastReliableAddTs < RELIABLE_ADD_WINDOW_MS) return;
                var d  = e && e.detail;
                var be = (d && d.baseEvent) || '';
                var looksLikeAdd = (be === 'add' || be === 'variant:add' || be === '');
                if (!looksLikeAdd) return;
                if (typeof be === 'string' && be.indexOf('cae:') === 0) return;
                var cart  = d && d.cart;
                var items = (cart && cart.items) || [];
                var last  = items.length ? items[items.length - 1] : null;
                if (!last) return;
                emitAddFromLine('cart:change', last, cart);
            } catch (err) { warn('cart:change add fallback', err); }
        }
        try { window.addEventListener('cart:change', _onCartChangeAdd); } catch (e) {}
        try { document.addEventListener('cart:change', _onCartChangeAdd); } catch (e) {}
    }

    /* ============================================================
       Event 9: cart_change — qty changes / removals
       ============================================================ */

    // #6: track the cart line-by-line so we can report WHAT changed (which line,
    // qty before→after, direction). Keyed by Shopify's unambiguous line.key.
    var _lastCartSnapshot = null;
    // Raw /cart.js cart object, kept fresh (load-seed + every cart:change/add) so
    // checkout_click can report the REAL line items — window.theme.cart is not
    // populated on this theme, which left checkout_click emitting an empty cart.
    var _lastFullCart = null;

    // Fetch the AUTHORITATIVE cart from /cart.js, refresh the _lastFullCart cache,
    // and hand the fresh cart to cb. The theme's event payloads (d.cart) lag
    // intermittently — right sometimes, stale others — so every cart-accurate
    // event reads /cart.js instead of trusting d.cart.
    function _fetchCartThen(cb) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return (r && r.ok) ? r.json() : null; })
            .then(function (c) { if (c) _lastFullCart = c; cb(c); })
            .catch(function () { cb(null); });
    }
    function _snapshotCart(cart) {
        var map = Object.create(null);
        try {
            var items = (cart && cart.items) || [];
            for (var i = 0; i < items.length; i++) {
                var it = items[i];
                if (!it) continue;
                var key = it.key || ((it.variant_id || it.id) + ':' + i);
                map[key] = { handle: it.handle || null, variant_id: it.variant_id || it.id || null, qty: it.quantity || 0 };
            }
        } catch (e) {}
        return map;
    }
    // Diff prev→next; returns {changed_line_handle, changed_variant_id, qty_before,
    // qty_after, direction} or null. null on first observation (no baseline → no
    // phantom 'added'). direction ∈ added|removed|increased|decreased.
    function _diffCart(prev, next) {
        if (!prev) return null;
        try {
            var k;
            for (k in prev) {
                if (!Object.prototype.hasOwnProperty.call(prev, k)) continue;
                var before = prev[k];
                var afterQty = (next[k] ? next[k].qty : 0);
                if (afterQty !== before.qty) {
                    return {
                        changed_line_handle: before.handle,
                        changed_variant_id:  before.variant_id,
                        qty_before:          before.qty,
                        qty_after:           afterQty,
                        direction:           (afterQty === 0) ? 'removed' : (afterQty > before.qty ? 'increased' : 'decreased')
                    };
                }
            }
            for (k in next) {
                if (!Object.prototype.hasOwnProperty.call(next, k)) continue;
                if (!prev[k]) {
                    return {
                        changed_line_handle: next[k].handle,
                        changed_variant_id:  next[k].variant_id,
                        qty_before:          0,
                        qty_after:           next[k].qty,
                        direction:           'added'
                    };
                }
            }
        } catch (e) {}
        return null;
    }

    function installCartChangeListener() {
        try {
            window.addEventListener('cart:change', function (e) {
                try {
                    var d    = e && e.detail;
                    var cart = d && d.cart;
                    if (!cart) return;
                    _fetchCartThen(function () {});  // refresh authoritative cart cache (d.cart lags)
                    var be = (d.baseEvent || '');
                    if (typeof be === 'string' && be.indexOf('cae:') === 0) return;
                    // An add seeds the baseline (so the next decrease/remove diffs
                    // correctly) but is NOT a cart_change — add_to_cart owns adds.
                    // Any add base event seeds the baseline and bails — adds are
                    // owned by add_to_cart. Must catch BOTH 'add' AND Prestige's
                    // 'variant:add' — the latter was slipping through and emitting a
                    // phantom cart_change with changed:null on every add-to-cart.
                    if (be === 'add' || be === 'variant:add') { _lastCartSnapshot = _snapshotCart(cart); return; }

                    var next    = _snapshotCart(cart);
                    var changed = _diffCart(_lastCartSnapshot, next);
                    _lastCartSnapshot = next;
                    // Only a REAL change is a cart_change. No diff (changed:null) =
                    // nothing actually changed (or an add already reflected) → skip
                    // the phantom emit. An 'added' diff is owned by add_to_cart.
                    if (!changed || changed.direction === 'added') return;

                    emit('cart_change', {
                        change_type:        be || 'cart_change',
                        cart_total_items:   cart.item_count   || 0,
                        cart_value_cents:   cart.total_price  || 0,
                        line_items_count:   (cart.items && cart.items.length) || 0,
                        line_item_handles:  (cart.items || []).map(function (it) { return it && it.handle; }).filter(Boolean),
                        changed:            changed
                    });
                } catch (err) { warn('cart:change handler', err); }
            });

            // Seed the baseline from the CURRENT cart at load. Without this,
            // _lastCartSnapshot starts null, so the FIRST cart:change (a delete
            // or qty edit) hits _diffCart(null, …) → null → no emit, and
            // cart_change only fired from the SECOND change (and again after
            // every reload). Best-effort + non-blocking; if an add or a first
            // cart:change seeds it first, the !_lastCartSnapshot guards keep the
            // fresher snapshot.
            if (!_lastCartSnapshot) {
                fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                    .then(function (r) { return (r && r.ok) ? r.json() : null; })
                    .then(function (c) { if (c) { _lastFullCart = c; if (!_lastCartSnapshot) _lastCartSnapshot = _snapshotCart(c); } })
                    .catch(function () {});
            }
        } catch (e) {}
    }

    /* ============================================================
       Event 10: checkout_click — delegated click on checkout button
       ============================================================ */

    function _emitCheckoutClick(cart) {
        var lineItems = (cart && cart.items) || [];
        emit('checkout_click', {
            cart_total_items: cart ? (cart.item_count || 0)  : null,
            cart_value_cents: cart ? (cart.total_price || 0) : null,
            line_items_count: lineItems.length,
            line_item_summary: lineItems.map(function (it) {
                return it && {
                    handle:     it.handle,
                    variant_id: it.variant_id,
                    quantity:   it.quantity,
                    a1:        (it.properties && it.properties._a1 === '1') || false,
                    a2:        it.properties && it.properties._a2 || null,
                    a3:        it.properties && it.properties._a3 || null
                };
            }),
            time_since_session_start_ms: Date.now() - getSessionStartMs()
        });
    }

    function installCheckoutClickDelegate() {
        document.addEventListener('click', function (e) {
            try {
                var t = e.target;
                if (!t || t.nodeType !== 1) return;
                var hit = (t.closest && (
                    t.closest('a[href*="/checkout"]') ||
                    t.closest('button[name="checkout"]') ||
                    t.closest('[data-checkout]')
                )) || null;
                if (!hit) return;

                // window.theme.cart is NOT populated on this theme — that's why this
                // used to emit an empty cart. Use the cached full cart (kept fresh by
                // the cart:change listener's load-seed + every cart:change). Only fall
                // back to a best-effort async fetch if the cache hasn't seeded yet
                // (rare: a click within ~100ms of load); that fetch can be lost if
                // navigation wins, which is acceptable.
                var cart = _lastFullCart || (window.theme && window.theme.cart) || null;
                if (cart) {
                    _emitCheckoutClick(cart);
                } else {
                    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                        .then(function (r) { return (r && r.ok) ? r.json() : null; })
                        .then(function (c) { _emitCheckoutClick(c); })
                        .catch(function () { _emitCheckoutClick(null); });
                }
            } catch (err) { warn('checkout click', err); }
        }, true);
    }

    /* ============================================================
       Transport bootstrap (interval + unload triggers)
       ============================================================ */

    // Leaving the page: park the product page_view and every card load still
    // waiting on its render delay into the queue, then beacon the whole queue.
    // EXITING stops emit() from starting its own keepalive fetch meanwhile.
    var EXITING = false;
    function onPageExit() {
        EXITING = true;
        try {
            sendPendingPageView();
            fireAllPendingImpressions();
            flush({ useBeacon: true, force: true });
        } catch (e) {}
        EXITING = false;
    }

    var flushIntervalId = null;
    function startTransport() {
        if (flushIntervalId) return;
        flushIntervalId = setInterval(function () { flush({}); }, FLUSH_INTERVAL_MS);
        try {
            // The parked product page_view goes into the queue BEFORE the flush
            // that is about to empty it - otherwise the beacon leaves without it.
            // Same for the card impressions still waiting on their render delay.
            // visibilitychange->hidden stays an exit signal: on mobile it is the last
            // event a tab reliably gets before the OS may kill it (pagehide often
            // never fires). A tab that comes back just carries on - its pending
            // loads were sent a moment early, which is the accepted trade-off.
            window.addEventListener('pagehide',           onPageExit);
            window.addEventListener('visibilitychange',   function () {
                if (document.visibilityState === 'hidden') onPageExit();
            });
            window.addEventListener('beforeunload',       onPageExit);
            window.addEventListener('online',             function () { flush({}); });
        } catch (e) {}
    }

    /* ============================================================
       Boot
       ============================================================ */

    function start() {
        installCardSeenObserver();
        installCardClickDelegate();
        installVariantChangeListener();
        installAddToCartListeners();
        installCartChangeListener();
        installCheckoutClickDelegate();

        emitSessionStartOnce();
        emitPageView();
        // A page the browser brings back from the back-forward cache never
        // loads again: no boot, no page_view. pageshow with `persisted` is the
        // one signal it was shown again - report it, so the clicks that follow
        // have a page to belong to. The initial pageshow (persisted false) is
        // the load this page_view already covered.
        try {
            window.addEventListener('pageshow', function (e) {
                if (e && e.persisted) emitPageView('bfcache');
            });
        } catch (e) {}

        startTransport();
        setTimeout(function () { flush({}); }, 1000);
    }

    function boot() {
        log('boot', { endpoint: ENDPOINT, viewer: getViewerId(), session: getSessionId() });
        captureUtm();
        captureEntry();

        var attempts = 0;
        function tryStart() {
            attempts++;
            if (window.SE_Engine || attempts > ENGINE_WAIT_MAX) {
                if (!window.SE_Engine) warn('boot: SE_Engine missing after wait — proceeding without engine enrichment');
                start();
                return;
            }
            setTimeout(tryStart, ENGINE_WAIT_MS);
        }
        tryStart();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }

    /* ============================================================
       Dev surface — window.CAEDev
       ============================================================ */

    window.CAEDev = {
        stats: function () {
            return {
                endpoint:    ENDPOINT,
                pulseType:   PULSE_TYPE,
                queueLength: loadQueue().length,
                sessionId:   getSessionId(),
                viewerId:    getViewerId(),
                debug:       DEBUG,
                utm:         captureUtm(),
                entry:       captureEntry(),
                device:      deviceContext(),
                country:     getCountry(),
                pageType:    pageType()
            };
        },
        queue:        function () { return loadQueue(); },
        flushNow:     function () { flush({ force: true }); return 'flushing'; },
        setDebug:     function (on) {
            DEBUG = !!on;
            try { localStorage.setItem(DEBUG_KEY, DEBUG ? '1' : '0'); } catch (e) {}
            return DEBUG;
        },
        setEndpoint:  function (url) { ENDPOINT = String(url || '').trim(); return ENDPOINT; },
        emit:         function (name, detail) { return emit(name, detail || {}); },
        clearQueue:   function () { saveQueue([]); return 'cleared'; },
        resetSessionStart: function () {
            try { sessionStorage.removeItem(SESSION_START_FIRED_KEY); } catch (e) {}
            return 'reset';
        }
    };
})();
